import { Flex, Icon, Text } from '@chakra-ui/react'
import { ElevatedButton } from 'Core/ElevatedButton'
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone'
import { BsFileEarmarkBinaryFill } from 'react-icons/bs'
interface IFileUploadProps {
  uploadDesc?: string
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T
  getInputProps: <T extends DropzoneInputProps>(props?: T | undefined) => T
  isLoading?: boolean
  fileName?: string
}

/**
 * @depends react-dropzone(https://www.npmjs.com/package/react-dropzone)
 * @param IFileUploadProps
 */
export const FileUpload: React.FC<IFileUploadProps> = (props: IFileUploadProps) => {
  const {
    uploadDesc = 'Drag and drop here or upload image/pdf',
    getRootProps,
    getInputProps,
    isLoading = false,
    fileName,
  } = props
  return (
    <Flex
      direction='column'
      alignItems='center'
      border='1px'
      borderStyle='dashed'
      borderColor='grey'
      borderRadius='lg'
      padding='2'
      {...getRootProps()}
      aria-label='drag and drop area'
    >
      <Icon marginTop='3' w='6' h='6' as={BsFileEarmarkBinaryFill} />
      <Text textAlign='center' padding='2' fontSize='sm' color='grey'>
        {uploadDesc}
      </Text>
      <input {...getInputProps()} />
      {fileName && (
        <Text paddingY='2' fontSize='sm' fontWeight='bold' color='secondary.800'>
          {fileName}
        </Text>
      )}
      <ElevatedButton colorScheme={'primary'} isLoading={isLoading} size='sm' marginBottom='3'>
        UPLOAD FILE
      </ElevatedButton>
    </Flex>
  )
}
